import { render } from "./ActiveRolesList.vue?vue&type=template&id=484ec772"
import script from "./ActiveRolesList.vue?vue&type=script&lang=js"
export * from "./ActiveRolesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__